import EventBusEventName from './EventBusEventName';
import * as actions from './actions';
import { EventBusState } from './reducer';

export interface EventBusEvent<EventDetails> {
  type: string;
  details?: EventDetails;
}

export type EventName = EventBusEventName | EventBusEventName[];
export type EventCallback<EventDetails> = (event: EventBusEvent<EventDetails>) => void;
export type AddListener = <EventDetails>(eventName: EventName, callback: EventCallback<EventDetails>) => () => void;
export type RemoveListener = <EventDetails>(eventName: EventName, callback: EventCallback<EventDetails>) => void;
export type Dispatch = <EventDetails>(eventName: EventBusEventName, eventDetails?: EventDetails) => void;

export interface EventBus {
  addListener: AddListener;
  removeListener: RemoveListener;
  dispatch: Dispatch;
}

export interface ListenerCollection {
  [eventName: string]: Array<EventCallback<any>>;
}

export const removeListener: RemoveListener = (eventName, callbackToRemove) => {
  if (Array.isArray(eventName)) {
    eventName.forEach((eventName) => removeListener(eventName, callbackToRemove));
    return;
  }

  window.top!.store.dispatch(actions.removeListener(eventName, callbackToRemove));
};

export const addListener: AddListener = (eventName, callback) => {
  if (Array.isArray(eventName)) {
    const removeListeners = eventName.map((eventName) => addListener(eventName, callback));
    return () => {
      removeListeners.forEach((removeListener) => removeListener());
    };
  }

  window.top!.store.dispatch(actions.addListener(eventName, callback));

  return () => {
    removeListener(eventName, callback);
  };
};

export const dispatch: Dispatch = (eventName, eventDetails) => {
  const listeners = (window.top!.store.getState().services.eventBus as EventBusState).listeners;

  if (!listeners[eventName]) {
    return;
  }

  listeners[eventName].forEach((listenerCallback) => {
    listenerCallback({
      type: eventName,
      details: eventDetails,
    });
  });
};
